
import {actionTypes} from '../constants/site';

const actions = {
    setLoadingMsg: (msg)=> ({
        type: actionTypes.SET_LOADING_MSG,
        payload: {msg}
    }),
    setModal: (modal)=> ({
        type: actionTypes.SET_MODAL,
        payload: {modal}
    })
}

export { actions };